var _defs, _sodipodiNamedview;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUw(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg2",
    xmlSpace: "preserve",
    width: 672,
    height: 269.34668,
    viewBox: "0 0 672 269.34668",
    sodipodiDocname: "UniversityOfWaterloo_logo_horiz_cmyk.eps",
    xmlnsInkscape: "http://www.inkscape.org/namespaces/inkscape",
    xmlnsSodipodi: "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsSvg: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs6"
  })), _sodipodiNamedview || (_sodipodiNamedview = /*#__PURE__*/React.createElement("sodipodiNamedview", {
    id: "namedview4",
    pagecolor: "#ffffff",
    bordercolor: "#666666",
    borderopacity: 1,
    inkscapePageshadow: 2,
    inkscapePageopacity: 0,
    inkscapePagecheckerboard: 0
  })), /*#__PURE__*/React.createElement("g", {
    id: "g8",
    inkscapeGroupmode: "layer",
    inkscapeLabel: "ink_ext_XXXXXX",
    transform: "matrix(1.3333333,0,0,-1.3333333,0,269.34667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g10",
    transform: "scale(0.1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 1534.58,1175.03 h 78.72 l 69.03,-225.85 74.89,226.82 h 62.85 l 74.84,-226.82 69.09,225.85 h 76.74 L 1926.8,839.059 h -63.79 l -75.25,218.221 -75.38,-218.221 h -63.84 l -113.96,335.971",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2156.96,1175.1 h 67.72 l 142.89,-336.041 h -76.67 l -30.5,74.882 h -141.06 l -30.52,-74.882 h -74.86 z m 77.24,-196.35 -44.28,108.16 -44.31,-108.16 z",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2447.59,1105.02 h -101.5 v 67.65 h 276.48 v -67.65 H 2521.11 V 839.059 h -73.52 v 265.961",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2678.39,1172.67 h 251.64 v -65.19 H 2751.3 v -67.71 h 157.31 V 974.371 H 2751.3 v -70.019 h 181.08 v -65.293 h -253.99 v 333.611",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path18"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3011.34,1172.67 h 152.57 c 42.37,0 75.25,-11.88 97.2,-33.86 18.57,-18.56 28.58,-44.71 28.58,-76.13 v -1.02 c 0,-53.89 -29.04,-87.762 -71.47,-103.461 l 81.44,-119.14 h -85.8 l -71.47,106.761 h -57.61 V 839.059 h -73.44 z m 147.75,-162.05 c 35.79,0 56.28,19.08 56.28,47.19 v 0.96 c 0,31.46 -22,47.66 -57.72,47.66 h -72.87 v -95.81 h 74.31",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3370.67,1172.67 h 73.38 V 905.781 h 156.19 v -66.722 h -229.57 v 333.611",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3611.53,1004.92 v 1 c 0,94.76 74.82,172.53 177.86,172.53 102.89,0 176.81,-76.77 176.81,-171.62 v -0.91 c 0,-94.908 -74.85,-172.58 -177.77,-172.58 -102.92,0 -176.9,76.742 -176.9,171.58 m 277.87,0 v 1 c 0,57.09 -41.9,104.84 -100.97,104.84 -59.12,0 -100.12,-46.74 -100.12,-103.93 v -0.91 c 0,-57.209 41.94,-104.932 101.08,-104.932 59.05,0 100.01,46.684 100.01,103.932",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path24"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3986.78,1004.92 v 1 c 0,94.76 74.81,172.53 177.71,172.53 103.01,0 176.87,-76.77 176.87,-171.62 v -0.91 c 0,-94.908 -74.82,-172.58 -177.78,-172.58 -102.94,0 -176.8,76.742 -176.8,171.58 m 277.89,0 v 1 c 0,57.09 -41.95,104.84 -101.09,104.84 -59.03,0 -100.06,-46.74 -100.06,-103.93 v -0.91 c 0,-57.209 41.96,-104.932 100.97,-104.932 59.12,0 100.18,46.684 100.18,103.932",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1720.82,1341.49 v 87.85 h 33.83 v -86.97 c 0,-25.02 12.52,-37.97 33.15,-37.97 20.64,0 33.16,12.51 33.16,36.88 v 88.06 h 33.83 v -86.73 c 0,-46.56 -26.15,-69.4 -67.42,-69.4 -41.3,0 -66.55,23.05 -66.55,68.28",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path28"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1944.71,1429.34 h 31.19 l 72.03,-94.65 v 94.65 h 33.37 v -153.71 h -28.77 l -74.45,97.7 v -97.7 h -33.37 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path30"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2177.47,1429.34 h 33.82 v -153.71 h -33.82 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path32"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2294.29,1429.34 h 37.32 l 40.2,-108.27 40.18,108.27 h 36.44 l -62.12,-154.82 h -29.87 l -62.15,154.82",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path34"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2529.89,1429.34 h 115.97 v -30.09 h -82.35 v -31.18 h 72.46 v -30.09 h -72.46 v -32.28 h 83.42 v -30.07 h -117.04 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path36"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2802.87,1354.67 c 16.45,0 25.9,8.78 25.9,21.75 v 0.44 c 0,14.49 -10.1,21.96 -26.57,21.96 h -33.59 v -44.15 z m -68.08,74.67 h 70.28 c 19.54,0 34.69,-5.48 44.79,-15.61 8.55,-8.55 13.17,-20.64 13.17,-35.12 v -0.44 c 0,-24.81 -13.41,-40.4 -32.94,-47.65 l 37.56,-54.89 h -39.54 l -32.92,49.19 h -26.58 v -49.19 h -33.82 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path38"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 2940.76,1298.02 19.98,23.93 c 13.84,-11.42 28.32,-18.66 45.9,-18.66 13.83,0 22.17,5.49 22.17,14.49 v 0.45 c 0,8.56 -5.27,12.95 -30.96,19.54 -30.96,7.9 -50.94,16.47 -50.94,47 v 0.42 c 0,27.9 22.41,46.35 53.79,46.35 22.41,0 41.51,-7.04 57.09,-19.54 l -17.57,-25.49 c -13.6,9.44 -27,15.15 -39.95,15.15 -12.96,0 -19.77,-5.92 -19.77,-13.39 v -0.45 c 0,-10.09 6.6,-13.37 33.17,-20.18 31.17,-8.13 48.74,-19.34 48.74,-46.12 v -0.45 c 0,-30.52 -23.29,-47.64 -56.44,-47.64 -23.27,0 -46.78,8.12 -65.21,24.59",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path40"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3151.13,1429.34 h 33.8 v -153.71 h -33.8 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path42"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3316.9,1398.15 h -46.76 v 31.19 h 127.35 v -31.19 h -46.78 v -122.52 h -33.81 v 122.52",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3524.41,1336.24 -59.06,93.1 h 39.52 l 36.68,-61.7 37.32,61.7 h 38.42 l -59.06,-92.45 v -61.26 h -33.82 v 60.61",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path46"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 3937.47,1352.04 v 0.43 c 0,26.35 -19.32,48.31 -46.55,48.31 -27.23,0 -46.12,-21.51 -46.12,-47.87 v -0.44 c 0,-26.33 19.32,-48.31 46.57,-48.31 27.21,0 46.1,21.52 46.1,47.88 z m -128.02,0 v 0.43 c 0,43.71 34.5,79.5 81.92,79.5 47.42,0 81.46,-35.36 81.46,-79.06 v -0.44 c 0,-43.69 -34.47,-79.48 -81.91,-79.48 -47.43,0 -81.47,35.34 -81.47,79.05",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 4045.47,1429.34 h 117.03 v -30.75 h -83.23 v -32.71 h 73.35 v -30.74 h -73.35 v -59.51 h -33.8 v 153.71",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1065.71,583.422 -8.98,4.199 C 956.953,633.789 876.438,700.859 823.84,781.559 697.715,975.082 693.555,1174.97 689.148,1386.6 c -0.339,16.04 -0.671,32.1 -1.074,48.22 l -0.515,21.89 h 755.901 l -0.54,-21.89 c -0.4,-16.21 -0.74,-32.38 -1.06,-48.52 -4.44,-211.51 -8.63,-411.339 -134.71,-604.741 -52.47,-80.59 -132.85,-147.637 -232.45,-193.938 l -8.99,-4.199",
    style: {
      fill: "#ffffff",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path52"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1063.97,1196.13 767.813,962.988 c -47.598,147.422 -46.282,301.552 -50.11,458.522 h 690.977 c -3.82,-157.35 -2.04,-310.87 -49.97,-458.639 l -294.74,233.259",
    style: {
      fill: "#fcd634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path54"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1303.81,837.172 c -7.31,-12.973 -15.11,-25.863 -23.49,-38.731 -52.67,-80.882 -130.91,-140.75 -216.95,-180.73 -86.39,39.98 -164.6,99.848 -217.296,180.73 -8.215,12.547 -23,37.809 -23,37.809 l 240.896,192.27 239.84,-191.348",
    style: {
      fill: "#fcd634",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 861.23,1303.16 c -35,7.43 -66.14,33.45 -58.632,66.46 0.078,0.31 -1.348,8.53 -4.368,9.66 -0.234,0.1 -0.73,1.02 -1.238,1.17 -1.34,0.34 -2.449,0.93 -3.574,1.72 -0.383,0.3 -2.023,0.85 -2.023,1.43 -0.625,-1.36 -0.497,-2.62 -1.434,-3.82 -0.32,-0.44 -0.828,-1.12 -1.328,-1.38 -0.625,-0.33 -0.672,-0.91 -1.16,-1.34 -2.629,-2.66 -1.223,-6.64 -0.813,-9.67 0.117,-0.76 0.442,-1.69 -0.488,-1.86 -1.121,-0.19 -0.227,0.3 -1.516,1.1 -0.308,0.19 -0.761,0.68 -1.093,0.84 -0.536,0.26 -2.723,0.55 -3.083,1.08 -0.402,0.58 -0.226,0.77 -0.753,1.23 -1.219,1.09 -1.329,3.26 -2.215,5.51 -0.157,0.39 -0.508,2.34 -0.508,2.78 0,2.23 -5.715,5.82 -3.496,3.98 0.762,-0.63 -0.129,0.91 -3.164,1.66 -1.938,0.49 -4.184,0.38 -6.34,0.11 -0.457,-0.07 -0.867,-0.44 -1.191,-0.68 -2.227,-1.72 -4.29,-3.77 -7.176,-3.91 0.476,0.31 0.742,-0.26 0.957,-0.51 1.375,-1.79 0.371,-3.97 1.187,-5.94 0.824,-1.92 2.219,-3.39 3.852,-4.71 1.597,-1.25 4.375,0.39 5.594,-1.78 0,0.07 2.609,-0.61 0.046,-3.18 -4.707,-4.75 -9.937,-0.91 -13.835,-9.71 5.898,2.55 6.562,-6.45 9.074,-6.78 11.277,-1.55 19.859,-3.54 26.051,-14.98 3.781,-6.97 -6.778,-7.3 2.777,-8.94 4.851,-0.82 8.094,-3.28 10.547,-6.71 2.566,-3.6 2.926,-8.44 5.672,-11.82 2.004,-2.4 2.761,-2.89 5.168,-4.91 1.089,-0.9 4.558,-1.81 5.859,-2.13 1.297,-0.35 2.078,-1 3.316,-1.45 1.321,-0.49 2.707,-0.95 3.821,-1.87 0.937,-0.78 3.332,-1.6 3.886,-2.68 0.977,-1.93 0.196,-3.89 1.231,-5.81 0.312,-0.53 1.797,-0.07 2.422,-0.26 0.586,-0.22 1.914,-0.29 2.285,-0.22 2.285,0.52 2.844,0.67 4.551,0.87 2.605,0.3 2.304,-0.5 5.683,-0.35 0.711,0 1.004,-0.52 1.973,-0.52 0.652,0 1.789,-0.71 1.98,-0.11 1.02,3.22 2.7,6.31 4.602,9.44 1.875,3.12 1.719,3.42 4.109,6.69 -0.281,-0.1 3.078,2.27 2.785,2.3",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path58"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 773.906,1299.09 c 10.254,-5.53 8.867,-19.16 18.106,-23.56 16.433,-7.83 36.054,-13.2 53.523,-4.62 -3.887,-12.15 0.41,-22.33 -1.289,-23.69 -5.484,-4.4 -22.168,0.84 -32.851,5.07 -7.364,2.93 -13.329,-8 -21.446,-7.05 0.41,0.96 1.328,3.76 0.781,5.49 -1.277,3.96 -2.3,5.1 -8.875,4.34 -4.25,-0.47 -2.48,-3.98 -8.835,-7.09 -2.512,1.48 -7.891,3.16 -8.672,-1.6 -0.364,-2.23 -4.844,7.75 -3.938,9.41 4.16,7.46 5.012,9.19 4.707,10.82 -0.488,2.46 -9.504,5.78 -10.676,3.71 -2.8,-4.92 -11.074,15.84 13.34,14.52 -6.558,4.21 -5.801,4.95 -4.273,9.98 0.191,0.68 -2.27,3.28 -3.938,1.49 -0.554,1.92 0.75,4.03 2.278,4.23 4.011,0.56 7.949,0.77 12.058,-1.45",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 822.488,1349.39 c 14.825,-3.41 36.977,15.72 49.836,-6.83 -9.492,3.46 -37.578,-11.58 -49.836,6.83",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 946.418,1316.62 c -0.297,-19.31 -20.297,-40.16 -4.074,-58.55 -6.621,0.1 -14.485,2.4 -19.09,6.14 -2.57,2.09 -2.004,-9.2 -1.66,-11.52 0.301,-1.98 -12.317,11.91 -17.063,8.51 -13.371,-9.62 -19.179,-13.59 -39.062,-14.32 -5.528,-0.2 -8.406,-4.66 -9.981,-9.49 -4.511,9.22 -1.152,30.18 1.438,39.49 7.027,25.53 32.676,33.11 53.25,45.31 14.758,8.78 21.074,25.94 20.32,42.67 10.473,-13.08 16.152,-31.81 15.922,-48.24",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 852.273,1099.2 c 2.5,-0.57 0.649,-2.64 -0.339,-3.26 -2.051,-1.37 -3.457,-3.03 -4.754,-5.08 -0.989,-1.5 -1.672,-3.15 -1.301,-5.02 0.254,-1.39 0.723,-2.62 1.238,-3.87 0.324,-0.78 1.047,-1.21 1.633,-1.86 0.234,-0.25 1.133,-1.38 1.152,-1.48 -0.547,1.96 2.2,3.93 2.84,3.56 12.738,-7.41 13.481,7.58 21.113,12.65 3.247,2.19 10.571,-0.33 8.672,-6.95 7.61,4.04 9.856,14.28 15.793,20.68 13.098,14.24 31.453,23.68 48.887,31.38 -6.309,6.7 -15.586,12.32 -20.293,19.98 -2.324,3.79 -5.105,11.25 0.039,9.87 21.426,-5.6 33.445,7.48 35.828,24.35 31.731,-4.1 39.979,25.89 44.259,48.57 2.07,10.99 8.1,11.95 1.51,30.71 -2.73,7.82 14.09,10.39 11.23,23.93 -0.81,3.74 -5.42,7.49 -8.16,7.94 2.6,-7.29 -9.62,-9.14 -10.95,-12.12 -2.057,-4.66 -5.072,-8.41 -5.482,-13.31 -10.344,14.3 -1.965,31.52 7.732,44.93 14.17,19.51 43.54,9.25 55.91,-3.33 0.22,6.32 -4.67,14.35 -8.7,18.22 11.56,1.48 24.11,-5.56 39.88,2.79 9.11,4.85 18.3,9 22.57,19.75 -19.36,-2.67 -45.61,12.23 -63.04,15.28 -32.54,5.63 -54.352,-16.53 -65.993,-43 -11.594,-26.42 -4.16,-46.15 8.418,-65.9 3.152,-4.98 -11.164,-1.7 -16.82,-4.64 -5.504,-2.83 -7.75,-9.63 -6.5,-15.63 6.929,7.45 25.32,2.85 26.968,-9.89 2.278,-17.2 -15.066,-42.24 -31.824,-34.73 -17.93,8.05 -28.086,26.97 -34.043,48.24 -15.312,-13.2 -43.66,-2.29 -56.824,-15.19 -12.524,-12.26 19.512,-20.57 31.98,-26.35 4.59,-2.15 9.2,-6.84 8.438,-12.64 -19.531,11.48 -43.059,-1.54 -41.902,-22.4 0.875,-15.6 19.957,-25.31 35.859,-26.62 6.609,-0.53 10.601,-7.92 2.547,-12.95 -14.121,-8.81 -29.856,-18.66 -45.071,-2.71 -2.539,2.67 -11.648,1.01 -13.457,-3.85 -0.886,-2.34 -1.171,-5.97 -0.796,-8.37 0.82,1.44 1.785,3.51 3.074,3.35 1.504,-0.19 3.332,-1.77 3.125,-2.88 -1.321,-7.86 -11.59,-2.78 -14.778,-8.87 -0.066,-0.12 -0.23,-0.24 -0.308,-0.37 -0.195,-0.51 -0.473,-0.94 -0.695,-1.39 -2.09,-4.14 -4.954,-6.74 0.175,-9.96 -0.136,0.76 2.539,-3.3 2.481,-4 0.254,3.75 4.16,3.69 4.16,3.69 l 2.266,-0.24 2.253,-1.01",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path66"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 786.172,1172.66 c -2.024,0.65 -4.121,-0.13 -6.113,-1.03 -1.27,-0.56 -2.801,0.04 -3.582,-1.25 -0.469,-0.8 -0.754,-1.66 -0.5,-2.56 0.128,-0.46 0.332,-1.35 0.734,-1.64 -2.68,0.22 -5.188,2.03 -7.238,3.87 -0.664,0.61 -1.075,1.27 -1.719,1.93 -0.399,0.43 -0.352,1.21 -0.625,1.8 -0.293,0.63 -0.164,1.34 -0.188,1.99 -0.066,1.83 -0.105,3.73 0.727,5.44 0.379,0.77 0.762,1.58 1.324,2.26 0.449,0.57 0.891,0.99 1.379,1.48 1.367,1.31 2.891,2.33 4.707,2.85 2.637,0.81 5.527,0.56 8.047,-0.54 2.012,-0.87 4.402,-0.77 6.516,-1.35 1.129,-0.32 3.242,2.94 1.707,3.31 -6.66,1.61 -6.621,3.43 -9.121,10.17 -1.164,1.32 -2.684,-0.2 -3.348,-0.89 -0.031,12.92 15.301,13.77 21.719,8.65 9.48,-7.63 2.351,-22.55 14.004,-26.68 6.074,-2.16 12.5,-3.82 18.765,-1.16 11.262,4.8 0.039,16.1 3.653,25.67 7.367,19.32 23.632,20.33 43.031,1.72 -17.348,-5.75 -25.449,-28.71 -15.957,-43.82 -15.293,5.99 -34.582,-4.12 -45.332,-10.98 9.976,10.02 -4.055,18.08 -7.602,16.31 l -4.258,-2.96 c -2.047,-2.59 -2.195,-5.27 -4.722,-7.74 -1.41,-1.37 -2.207,-1.64 -4.055,-2.12 -2.539,-0.66 -4.109,-0.46 -6.379,1.04 -0.406,0.26 -1.785,-0.32 -2.039,-0.66 -1.23,-1.51 -0.039,-2.25 -0.066,-2.82 -0.246,0.2 -1.836,1.48 -2.075,1.66 -1.433,1.09 -3.093,2.03 -4.003,3.5 -0.895,1.5 -1.512,5.25 -0.489,7.3 1.008,2.02 3.039,2.66 4.399,4.04 1.289,1.3 -0.246,3.28 -1.789,3.51",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path68"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1158.51,1343.18 c 1.37,-0.88 -0.11,-3.38 -1.68,-3.82 -1.87,-0.52 -4.48,0.27 -6.11,-0.37 -7.29,-2.68 -7.31,-20.62 -6.31,-18.55 1.1,2.3 6.48,0.8 9.96,0.11 5.63,-1.14 9.89,10.29 13.59,9.98 8.77,-0.79 16.95,-11.69 20.29,-18.85 0.61,-1.31 -3.67,-1.36 -3.95,-5.77 11.94,1.13 22.03,-6.62 30.65,-13.71 4.21,7.3 8.44,11.82 13.21,16.59 -17.95,17.48 -53.63,22.87 -48.13,54.71 0.73,4.08 -3.89,7.68 -5.94,9.69 -2.32,2.21 -7.61,2.35 -10.85,3.11 3.41,-7.06 -2.74,-7.75 -1.85,-18.94 0,-0.36 -1.02,-0.12 -1.41,0.03 -2.14,0.93 -3.96,2.26 -6.02,3.54 -1.84,1.15 -3.57,0.85 -5.61,0.54 -1.25,-0.17 -2.37,-0.74 -3.42,-1.49 -1.7,-1.21 -2.57,-2.78 -3.74,-4.51 -0.24,-0.3 -0.47,-0.67 -0.73,-0.95 -0.39,-0.39 -1.15,-1.6 -1.2,-2.2 0.93,0.09 3.83,-0.13 4.32,-0.91 0.83,-1.3 0.86,-2.8 1.85,-4.04 1.23,-1.57 2.26,-1.62 4.05,-2.37 2.8,-1.18 5.29,-1.7 8.34,-1.44",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path70"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1204.92,1356.01 c 11.21,0.82 22.32,9.42 34.71,-5.11 -2.3,1.08 -4.95,1.46 -6.35,0.34 -13.71,-11.05 -30.36,-7.31 -39.14,6.38 3.57,0.57 7.89,-1.83 10.78,-1.61",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path72"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1253.41,1315.34 c 18.42,9.31 37.03,16.8 44.61,39.64 1.48,4.46 4.89,-6.64 5.11,-7.27 9.73,-27.88 -9.68,-55.57 -5.69,-84.03 -6.48,3.97 -13.78,6.7 -20.9,6.91 -25.28,0.74 -31.27,-14.64 -32.7,-13.2 -6.94,7 -26.85,13.01 -25.4,11.7 -11.82,10.92 22.29,39.77 34.97,46.25",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path74"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1203.07,1129.79 c 2.53,-3.88 -0.83,2.21 2.04,-4.41 13.33,5.58 27.13,11.97 41.87,5.98 -6.53,29.98 15.35,37.27 17.08,41.76 2.78,7.18 -11.84,21.49 -22.87,17.5 -14.06,-5.03 -8.21,-22.78 -10.85,-35.2 -1.46,-6.86 -9.97,-11.9 -17.03,-9.46 -11.64,4.01 -16.31,14.85 -19.19,27.01 -1.92,8.1 -17.68,9.08 -21.08,2.45 -9.68,-18.81 5.75,2.18 4.74,-12.11 -0.16,-2.41 -11.3,-0.59 -13.8,-9.06 -1.69,-5.77 3.78,-9.63 10.67,-11.66 1.26,-0.36 -1.34,2.86 0.4,3.57 1.24,0.49 6.3,-2.22 5.69,-2.55 -6.63,-4.06 -8.32,-13.45 3.53,-17.54 0.08,-0.03 -0.86,3.38 0.03,4.05 9.26,6.9 18.91,-0.57 18.93,-0.33",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path76"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1002.58,940.211 c 11.08,-5.109 14.67,0.391 29.24,2.738 2.04,0.352 10.24,-5 12.62,-7.719 -14.6,-2.32 -32.37,-15.039 -41.86,4.981",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path78"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 996.648,928.551 c -0.679,0.758 -1.636,1.058 -2.539,1.41 -0.894,0.43 -1.875,0.758 -2.925,0.879 -0.254,0.082 -2.09,0.492 -2.375,0.582 -0.059,-0.641 0.781,-2.344 0.3,-2.774 -1.16,-1.089 -1.582,-0.82 -2.515,-2.226 -0.344,-0.563 -0.703,-1.113 -0.852,-1.731 -0.262,-1.269 -0.82,-2.742 -0.976,-4.179 -0.047,-0.75 0.254,-2.481 0.422,-3.133 0.093,-0.367 0.875,-1.949 1.101,-2.379 0,0 1.77,-1.898 1.672,-1.82 2.051,-2.09 0.367,-0.86 2.898,-3.379 1.289,-1.211 -0.586,-3.321 -1.828,-2.992 -8.57,2.492 -9.773,12.453 -17.586,15.492 -5.683,2.187 -13.855,-2.219 -14.726,-10.879 1.926,0.547 3.918,-0.172 4.297,-1.774 2.089,-8.707 14.875,-3.519 15.175,-9.648 0.227,-4.031 -9.558,0.68 -13.425,-1.879 -5.121,-3.41 -5.813,-13.242 -1.301,-18.961 4.648,4.43 10.437,-2.051 14.953,1.168 3.16,2.274 4.285,5.473 7.52,6.891 9.824,4.34 12.71,-4.699 10.535,-13.778 5.312,2.438 17.797,5.02 20.657,5.821 5.17,1.398 5.4,13.34 11.73,17.726 -8.99,0.024 -20.09,3.953 -22.59,12.703 -0.24,0.93 0.4,2.008 0.49,3.059 0.21,3.34 -0.09,6.578 -1.36,9.648 -0.13,0.332 -0.46,0.743 -0.69,1.133 -0.36,0.469 -0.66,0.981 -1,1.508 -0.9,1.231 -2.218,1.813 -3.495,2.609 -0.57,0.383 -1.274,0.473 -1.684,1.043",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 930.652,866.699 c 3.926,-7.66 -15.437,4.59 -22.691,-6.719 -2.316,-3.628 -1.074,-11.82 -1.074,-16.429 4.441,4.051 8.875,-3.653 17.183,3.711 0.918,-0.84 1.907,-1.34 0.649,-2.633 -3.071,-3.09 -4.785,-6.957 -3.164,-10.668 1.011,-2.441 7.91,-7.281 7.965,-6.871 0.707,4.98 9.21,0 10.539,9.781 0.578,4.051 1.757,10.758 7.617,8.32 5.32,-2.203 6.426,-8.242 5.183,-14.25 8.508,2.789 23.457,11.52 32.383,5.047 12.004,-8.648 31.698,-12.238 45.748,-16.597 -9.32,6.488 -12.28,23.359 -10.73,34.359 -22.108,-4.359 -45.299,-3.621 -65.795,5.859 -5.61,2.61 -4.856,9.082 -6.543,14.411 -1.926,6.019 -9.477,11.558 -16.328,11.039 -3.684,-0.278 -12.531,-8.008 -10.852,-8.399 -0.566,0.141 -0.554,-1.109 -0.84,-1.68 1.661,1.051 3.77,0 4.524,-1.8 0.535,-1.25 1.062,-2.621 2.117,-3.629 1.25,-1.231 3.418,-1.52 4.109,-2.852",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path82"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 983.633,745.898 c 4.289,5.274 7.859,2.461 9.734,2.422 4.485,-0.16 4.172,-6.492 3.723,-10.511 17.58,8.523 34.31,20.632 54.94,16.191 -12,12.559 -7.75,39.531 9.22,42.852 0.05,0 -10.96,1.796 -12.11,2.539 -14.76,9.359 -32.81,18.3 -42.73,-1.332 -4.95,-9.739 4.12,-17.629 10.89,-25.661 1.24,-1.457 -0.74,-2.339 -2.33,-2.75 -16.142,-4.136 -45.888,-6.57 -47.216,17.59 -0.149,2.434 -6.387,4.442 -10.41,4.34 -11.961,-0.367 -11.77,-15.609 -10.403,-14.547 2.61,1.969 10.618,1.27 9.653,-4.84 -0.903,-5.711 -12.043,3 -16.496,-2.742 -3.719,-4.758 -3.606,-12.64 -0.957,-17.91 -0.536,1.922 1.718,3.359 2.922,3.543 12.402,2.09 13.093,-2.23 9.421,-14.242 -0.285,-0.899 3.672,-8.5 6.282,-9.18 -0.207,0.078 -0.168,1.738 0.183,2.301 0.352,0.59 0.957,1.019 1.594,1.23 1.348,0.43 2.715,0.368 4.078,0.731 0.649,0.187 1.137,0.598 1.75,0.969 0.969,0.609 1.633,1.468 2.324,2.371 2.903,3.609 5.43,8.258 10.293,8.726 2.239,0.211 3.66,-0.797 5.598,-2.027",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path84"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1111.9,689.859 c 11.32,11.27 19.52,26.27 31.64,37.231 -13.29,7.851 -29.76,15.988 -31.51,33.57 -0.13,1.192 1.85,2.5 2.32,2.289 18.46,-10.367 43.37,-11.187 56.7,7.672 10.74,15.258 15.41,40.02 36.38,41.43 -6.97,13.418 0.87,28.89 12.35,35.961 -3.88,1.457 -8.85,4.617 -13.21,3.816 -5.28,-0.887 -7.56,-8.078 -13.59,-9.18 9.49,31.981 -8.86,76.661 -44.09,75.883 -6.6,-0.133 -15.17,-5.453 -17.33,-12.691 -2.03,-6.801 -3.07,-15.352 1.83,-21.192 11.54,-13.808 19.86,-28.886 16.22,-47.089 8.23,7.07 15.81,17.523 15.53,28.652 -0.05,2.789 5,0.801 5.79,1.949 9.62,14.102 -6.13,22.828 -14.48,31.719 -2.32,2.402 3.57,6.133 4.32,5.883 30.21,-9.043 33.07,-46.25 20.13,-70.453 -3.45,4.32 -16.24,2.89 -20.57,4.363 14.13,-7.133 10.47,-8.152 9.88,-10.492 -1.07,-4.258 -13.75,-2.399 -16.21,-5.532 -4.23,-5.41 -7.43,-7.808 -7.76,-25.796 5.87,6.328 13.55,15.918 21.88,11.636 17.78,-9.136 -0.88,-39.879 -17.66,-44.976 -14.33,-4.321 -27.59,0.226 -36.47,12.707 -12.83,18.051 -3.52,39.91 -12.62,58.211 -7.6,-1.879 -5.87,-11.782 -9.83,-10 -13.96,6.461 -21.9,21.398 -32.03,33.922 -4.19,-1.5 -6.04,-5.391 -10.09,-5.192 -5.97,0.25 -17.26,2.09 -19.67,-0.922 -2.78,-3.5 -4.83,-28.886 19.87,-38.066 16.76,-6.274 30.04,-11.832 40.59,-24.922 -7.08,-0.559 -9.55,2.852 -15.33,3.07 -5.68,0.211 -9.28,-2.011 -13.58,-4.199 -4.11,-2.133 -8.93,-10.199 -8.12,-16.621 3.87,-30.738 39.95,-31.148 56.56,-50.609 2.86,-3.282 -4.36,-16.641 -11.15,-22.051 -5.79,-4.629 -19.68,6.969 -17.42,16.781 1.83,7.828 -17.12,13.09 -23.76,4.098 2.65,0.312 3.3,-1.438 3.06,-2.66 -1.17,-7.239 7.8,-7.508 7.51,-11.188 -0.41,-5.07 -4.81,2.129 -8.26,2.777 -7.66,1.543 -15.25,-1.136 -19.72,-7.269 -1.36,-1.82 -4.36,-4.777 -3.03,-7.93 5.85,2.852 8.9,-6.25 14.34,-3.418 3.31,1.68 6.03,4.61 10.02,3.598 1.59,-0.43 3.24,-2.578 1.8,-3.5 -10.65,-6.828 -19.17,-16.418 -11.46,-27.32 0.2,2.543 2.21,4.332 3.83,4.781 3.1,0.898 7.21,-1.25 10.24,-0.25 4.95,1.68 2.39,6.582 4.3,10.101 2.95,5.579 13.01,14.739 18.66,8.059 1.05,-1.211 0.23,-5.699 -2.81,-5.738 3.12,0.039 5.92,-3.012 8.57,-2.442 0.75,0.121 1.55,0.121 2.23,0.489 0.6,0.293 1.29,0.429 1.73,0.91 1.25,1.25 2.69,2.582 2.9,4.582 2.27,-0.199 5.16,-0.43 6.66,1.519 1.44,1.95 3.25,3.461 4.85,4.942",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1060.42,912.109 c 19.79,5.539 41.78,15.821 46.51,37.813 6,-3.613 7.89,-11.82 7.96,-16.844 0.43,-27.547 -11.62,-51.359 -5.77,-80.226 0.66,-3.262 6.62,-13.524 3.91,-12.301 -3.29,1.5 -10.26,8.019 -14.09,5 -4.79,-3.77 -4.48,-9.711 -6.78,-8.332 -8.69,5.32 -17.89,13.133 -22.12,23.211 -1.64,3.832 -0.96,11.992 -2.04,10.82 -6.59,-7.211 -20.13,-8.75 -30.16,-10.281 2.3,2.062 4.34,10.261 3.98,11.961 -7.88,3.941 -19.21,-9.532 -19.03,-7.809 0.42,4.348 0.89,5.699 1.31,6.891 5.87,17.269 16.94,34.75 36.32,40.097",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 899.309,1370.69 c 0.828,0.37 1.257,0.95 1.152,1.06 -7.18,10.05 -15.82,9.06 -19.477,0.09 -2.468,-6.06 11.965,-4.11 18.325,-1.15 m 14.031,10.69 c 5.129,0.13 8.926,3.31 12.187,6.77 -0.261,-2.89 3.977,-6.98 2.403,-10.06 -1.953,-3.86 -6.907,-6.17 -7.871,-9.78 -2.039,-7.33 3.867,-14.52 -0.442,-21.82 -12.715,-21.5 -40.437,-14.37 -59.383,-19.14 1.297,2.32 -0.332,5.76 -1.75,6.73 8.411,-1.09 19.582,0.76 21.848,7.1 2.766,7.84 4.148,13.62 0.481,20.08 -6.086,10.67 -18.696,5.68 -28.168,1.98 -1.493,6.61 4.71,10.63 8.285,11.55 10.039,2.64 19.136,7 28.496,10.47 8.14,3.06 15.562,-4.09 23.914,-3.88",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path90"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1266.88,1374.51 c 0.79,0.46 -0.64,-0.62 0.02,0.05 -7.84,3.92 -18.04,9.07 -21.63,-1.4 -2.63,-7.68 14.81,-2.3 21.61,1.35 m 12.56,-33.64 c -2.71,-2.34 -7.23,-2.28 -10.31,-4.37 -1.87,-1.32 -3.57,-2.7 -5.52,-3.86 -0.91,-0.58 -3.64,-1.8 -4.63,-2.03 -2.76,-0.72 -2.16,-0.39 -4.7,-0.72 -1.54,-0.22 -2.25,-0.29 -3.77,-0.29 -1.53,0 -6.2,-0.14 -7.7,-0.1 -3.61,0.07 -4.23,-0.17 -7.83,0.39 -2.08,0.33 -4.06,0.89 -6.02,1.56 -1.31,0.43 -2.71,0.68 -4.09,0.71 0.17,1.45 0.34,3.01 1.48,3.95 1.5,1.3 1.79,0.14 3.99,0.34 0.1,0.01 3.11,-0.25 3.22,-0.25 0.5,0.02 1.12,0.04 1.65,0.11 0.95,0.14 1.75,0.32 2.59,0.74 1.09,0.51 2.26,0.83 3.24,1.61 0.34,0.3 0.74,0.57 1.08,0.91 0.72,0.68 1.7,1.03 2.35,1.85 2.06,2.51 3.61,4.94 3.82,8.18 0.22,2.4 0.4,4.86 -0.05,7.32 -0.07,0.39 -0.13,0.8 -0.16,1.14 -0.16,1.9 -1.09,3.68 -2.02,5.46 -5.49,10.47 -18.7,0.22 -27.74,0.69 0,2 -0.18,5.68 0.84,6.99 6.45,8.3 16.42,4.22 21.58,8.03 17.41,12.89 22.03,3.6 40.21,-1.44 5.46,-1.51 13.27,1.94 18.43,4.15 1.26,0.53 1.25,-7.69 0.6,-9.37 -2.16,-5.75 -8.12,-5.46 -10.21,-10.62 -3.07,-7.59 -3.55,-18.25 -11.56,-22.08",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path92"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1061.49,954.18 c 3.11,-1.149 12.33,3.922 15.67,5.8 0.82,0.45 1.38,1.25 2.03,1.911 0.05,0.078 -0.07,0.281 -0.2,0.3 -2.64,0.559 -5.04,0.758 -7.62,1.028 -1.95,0.242 -3.39,1.562 -5.33,1.91 -0.51,0.141 -0.98,0.062 -1.51,-0.129 -0.74,-0.289 -1,-0.82 -1.61,-1.121 -0.93,-0.418 -2.26,-0.418 -3.1,-1.207 -0.86,-0.762 -1.6,-1.5 -1.86,-2.613 -0.35,-1.289 -0.07,-3.168 0.83,-4.258 0.69,-0.879 1.74,-1.27 2.7,-1.621 m 23.92,14.082 c 8.05,-1.91 16.82,-2.172 22.03,4.859 2.56,-10.902 -7.43,-12.281 -9.29,-17.59 -2.81,-8.133 -2.62,-16.25 -10.48,-20.429 -15.66,-8.34 -35.24,-18.34 -53.2,-19.832 0.14,2.21 -1.37,6.23 1.51,6.371 6.29,0.289 11.18,4.98 12.6,8.687 1.97,5.184 -0.27,17.731 -4.96,20.203 -5.41,2.848 -10.15,-1.531 -15.13,-3.722 -2.08,5.511 6.5,14.632 19.96,13.851 -0.35,0.02 6.67,7.66 6.34,7.418 8.79,6.043 18.43,2.992 30.62,0.184",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path94"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1329.58,1044.51 c -0.26,2.66 6.36,10.55 6.52,16.35 0.63,19.71 12.5,29 12.86,50.06 0.07,5.51 -22.68,10.66 -23.68,22.5 -0.47,5.87 -2.41,14.36 3.47,14.22 7.55,-0.13 14.96,1.21 20.29,5.92 23.81,20.96 3.71,49.58 0.84,74.86 -0.63,5.56 9.62,17.48 9.32,21.41 -1.64,21.45 -5.62,41.01 2.02,62.07 -5.99,-5.35 -7.78,-14.19 -12.8,-18.72 -2.45,-2.26 -3.64,2.74 -3.48,3.51 3.01,18.53 10.39,34.76 18.97,52.37 10.15,20.87 5.06,37.83 -13.71,44.06 -17.22,5.74 -33.84,-10.29 -35.71,-26.75 -1.73,-15.11 2.98,-33.22 6.55,-45.58 1.03,-3.62 0.42,-7.74 1.19,-10.88 3.07,12.49 3.41,25.53 3.21,38.74 -0.05,3.22 2.52,7.53 5.82,8.48 11.19,3.24 16.97,-4.85 16.23,-11.11 -2.46,-19.8 -6.45,-34.95 -11.19,-54.61 -5.4,-22.43 2.64,-44.69 5,-66.49 -8.6,5.05 -17.97,5.3 -21.29,-8.12 -1.81,-7.12 4.63,-14.61 6.6,-20.91 0.2,8.57 8.29,20.27 16.15,15.04 9.64,-6.41 9.99,-37.19 7.87,-41.27 -4.69,-8.91 -12.39,-15.28 -23.07,-12.13 -6.02,1.77 -3.58,10.68 -7.18,14.45 -19.2,19.85 -27.94,43.57 -29.57,70.99 -0.27,4.01 1.83,14.55 1.25,14.77 -25.11,10.34 -36.66,0.04 -47.08,-14.77 -1.79,4.48 -11.37,10.74 -12.13,9.35 -4.76,-8.84 -3.4,-24.87 3.74,-31.07 19.35,-16.75 38.53,-27.96 49.4,-51.89 -11.61,-1.52 -22.94,-4.88 -27.4,-17.01 -4.64,-12.67 -3.05,-30.28 10.33,-35.44 10.9,-4.18 29.63,0.49 33.74,-0.02 11.59,-1.5 24.55,-11.5 22.73,-22.48 -0.09,-0.55 -4.96,-26.13 -16.05,-19.78 -6,3.44 -2.63,17.46 -11.77,19.67 -12.32,2.97 -15.34,-14.24 -13.77,-12.74 3.91,3.73 6.64,-2.44 14.26,-6.66 -25.78,5.61 -17.78,-18.04 -16.84,-15.43 1.33,3.67 6,-0.17 15.24,0.47 0.34,0 -2.02,-1.93 -2.14,-2.13 -1.45,-2.38 -2.17,-3.53 -3.22,-6.03 -0.5,-1.17 -0.45,-2.46 -0.27,-3.69 0.11,-1.29 0.57,-2.39 1.24,-3.48 0.13,-0.25 0.37,-0.47 0.65,-0.59 0.11,-0.04 0.48,-0.62 0.55,-0.62 0.56,-0.08 -0.51,1.81 1,1.91 0.34,0.04 1.44,0.2 1.73,0.1 0.68,-0.27 1.56,-0.71 2.27,-0.9 0.67,-0.17 1.36,-0.29 2.1,-0.43 1.76,-0.22 2.37,-0.27 3.92,0.26 1.3,0.46 2.59,0.73 3.83,1.6 -1.66,-1.14 1.82,1.66 1.67,1.36 1.6,3.42 2.59,2.44 2.94,3.05 2.74,5.22 5.12,5.7 11.19,4.98 0.58,-0.06 1.7,-1.29 2.06,-1.84 0.43,-0.64 1.68,-3.92 1.46,-2.71 0.43,-2.42 1.93,-3.92 2.14,-6.27",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path96"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1143.64,1281.86 c -1.56,1 -2.08,3.39 -3.15,4.37 -0.33,0.36 -0.62,0.77 -0.96,1.15 -0.54,0.55 -0.79,1.3 -1,2.08 -1.07,3.67 -0.52,8.03 2.81,10.47 0.12,0.12 0.1,0.33 0.16,0.46 0.17,0.34 0.68,0.51 0.77,0.79 0.09,0.32 0.65,0.32 0.46,0.74 0.24,-0.11 0.25,0.21 0.34,0.29 0.66,0.86 0.69,2.39 -0.59,2.82 1.06,-0.09 2.15,-0.07 3.22,-0.3 0.42,-0.09 0.85,-0.21 1.25,-0.27 4.08,-0.53 9.2,-2.37 10.3,-6.45 l 1.42,-1.64 c 4.24,-9.85 2.79,-34.08 26.38,-39.91 12.28,-3.03 24.65,-6.84 37.24,-6.63 -3.03,-12.28 -3,-27.85 6.73,-36.75 -14.16,7.72 -23.59,6.09 -35.89,17.73 -5.5,5.21 -18.31,12.31 -24.49,11.26 -2.55,-0.43 3.53,8.17 -2.15,9.89 -3.72,1.11 -13.65,0.87 -15.35,-1.67 -8.16,-12.29 -16.76,-12.22 -19.63,-14.7 3.31,2.82 -13.36,16.42 7.35,23.79 1.98,0.73 2.7,5.23 0.27,6.36 -4.06,1.87 -7.43,-0.92 -11.43,-3.26 -4.59,-2.72 -5.65,7.25 -12.84,3.57 -1.49,21.3 17.48,23.13 28.78,9.85 0.8,-1.01 3.96,0.2 2.65,1.33 l -2.65,4.63",
    style: {
      fill: "#cf113f",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path98"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 1400.94,1374.55 c -2.92,-139.89 -5.78,-274.37 -46.88,-404.198 L 1063.91,1200.71 772.539,969.691 c -41.316,130.079 -44.172,264.859 -47.101,405.059 -0.27,13.32 -0.543,26.66 -0.86,40.04 h 677.242 c -0.32,-13.44 -0.6,-26.85 -0.88,-40.24 z M 1274.69,802.09 C 1227.07,728.98 1154.03,667.832 1063.36,625.102 972.559,667.711 899.402,728.871 851.688,802.09 843.699,814.352 836.277,826.66 829.297,839 l 234.583,185.96 233.51,-185.409 c -7.07,-12.539 -14.6,-25 -22.7,-37.461 z m -488.01,127.281 277.2,219.739 276.04,-219.149 c -6.94,-18.09 -14.71,-36.082 -23.42,-53.973 L 1063.91,1076.54 810.176,875.371 c -8.731,17.91 -16.531,35.918 -23.496,54 z m -75.852,498.839 0.168,-6.86 c 0.383,-15.67 0.703,-31.3 1.024,-46.89 4.242,-203.28 8.234,-395.28 128.418,-579.722 49.589,-76.09 125.707,-139.406 220.112,-183.117 l 2.83,-1.332 2.81,1.332 c 94.28,43.828 170.27,107.168 219.75,183.117 120.15,184.364 124.18,376.302 128.41,579.532 0.34,15.65 0.67,31.34 1.05,47.08 l 0.17,6.86 H 710.828",
    style: {
      fill: "#231f20",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    id: "path100"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUw);
export default __webpack_public_path__ + "static/media/UW.9a64da0b42b222cd178c1584a78d88d4.svg";
export { ForwardRef as ReactComponent };